
import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import axios from "axios";
import { useAuth } from "../../Context/AuthContext.jsx";

const Add = ({ activeTab, AllReferallInfo }) => {
  const [search, setSearch] = useState("");
  const [userinfo, setUserinfo] = useState([]);
  const [proxyfirstname, setProxyfirstname] = useState("");
  const [proxylastname, setProxylastname] = useState("");
  const [proxyemail, setProxyemail] = useState("");
  const [proxycountry, setProxycountry] = useState("India");
  const [proxyphonenumber, setProxyphonenumber] = useState("");
  const [proxyprogram, setProxyprogram] = useState("MBA");
  const [error, setError] = useState("");
  const [referralerror, setReferralerror] = useState("");
  const [countries, setCountries] = useState([]);
  const [referrermessage, setReferrermessage] = useState("");
  const [errormessage, setErrormessage] = useState("");
  const [errorPhone, setErrorPhone] = useState("");
  const [successmessage, setSuccessmessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { token, user } = useAuth();
  const utmSource = user?.source?.[0] || "defaultSource";
  const utmMedium = user?.medium?.[0] || "defaultMedium";
  const utmCampaign = user?.campaign?.[0] || "defaultCampaign";

  const referralUrl = `${process.env.REACT_APP_FRONTEND_URL}/?utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}`;

  const emptySearch = () => {
    setSearch("")
    setUserinfo([])
  }

  async function checkforEmail(event) {
    event.preventDefault();
    if (search.trim() !== "") {
      try {
        const resp = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/users/email/${search.trim()}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (resp.status === 200) {
          setUserinfo(resp.data.user.userInfo);
          setError("");
        }
      } catch (error) {
        setError(error.response?.data?.message || "User not found");
        setUserinfo([]);
        setTimeout(() => setError(""), 3000);
      }
    }
  }

  async function saveProxyDetail(event) {
    event.preventDefault();
    if (userinfo && Object.keys(userinfo).length > 0) {
      setIsSubmitting(true);
      try {
        const resp = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/api/referrals/proxy-lead`,
          {
            candidate_name: proxyfirstname + " " + proxylastname,
            candidate_email: proxyemail,
            candidate_phone: proxyphonenumber,
            candidate_program: proxyprogram,
            candidate_country: proxycountry,
            campaign: "NA",
            utm_source: "Proxy",
            medium: "NA",
            referrer_id: userinfo.id,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (resp.status === 201) {
          if (AllReferallInfo) AllReferallInfo();
          setSuccessmessage(resp.data?.message || "Referral registered successfully.");
          resetForm();
          setTimeout(() => setSuccessmessage(""), 4000);
        }
      } catch (error) {
        if (error.response?.data?.errors) {
          setReferralerror(error.response.data.errors[0].isEmail || "")
          setErrorPhone(error.response.data.errors[0].isPhoneNumber || "")
        } else {
          setReferralerror("")
          setErrorPhone("")
        }

        setErrormessage(error.response?.data?.message || "Something went wrong")
        setTimeout(() => {
          setErrormessage("")
          setReferralerror("")
          setErrorPhone("")
        }, 3000)
      } finally {
        setIsSubmitting(false);
      }
    } else {
      setReferrermessage("Please select a valid search result first.")
      setTimeout(() => setReferrermessage(""), 3000)
    }
  }

  const resetForm = () => {
    setProxyfirstname("");
    setProxylastname("");
    setProxyemail("");
    setProxycountry("India");
    setProxyphonenumber("");
    setProxyprogram("MBA");
    setUserinfo([]);
    setSearch("");
  };

  const fetchCountries = async () => {
    try {
      const response = await axios.get('https://restcountries.com/v3.1/all?fields=name,flags');
      let countryNames = response.data.map(country => country.name.common).sort();
      setCountries(countryNames);
    } catch (err) {
      console.log(err)
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  if (activeTab !== 9) return null;

  return (
    <div className="animate-fadeIn pb-12">

      {/* UTM Information Section */}
      {user.user_type === 'SalesCounselor' && (
        <div className="bg-gradient-to-r from-[#004f6b] to-[#003e54] rounded-2xl shadow-xl p-6 mb-8 text-white relative overflow-hidden group">
          <div className="absolute top-0 right-0 p-8 opacity-10 transform translate-x-4 -translate-y-4">
            <svg className="w-32 h-32" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79l4.29 4.29v1c0 1.1.9 2 2 2v1.44zm6.7-3.53c-.1-.1-.1-.21-.2-.31l-3.5-3.5v-2c0-1.1-.9-2-2-2h-2.42l3.71-3.71c.71.44 1.28 1.05 1.71 1.71l.01.01c.44.71.69 1.53.69 2.42 0 .62-.08 1.21-.21 1.79l-4.29-4.29v-1c0-1.1-.9-2-2-2v-1.44c3.95.49 7 3.85 7 7.93 0 .62-.08 1.21-.21 1.79l-4.29-4.29z" /></svg>
          </div>
          <div className="relative z-10 flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="space-y-2">
              <h3 className="text-xl font-bold flex items-center gap-2">
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" /></svg>
                Your Referral Accelerator
              </h3>
              <p className="text-blue-100 text-sm opacity-90">Share this unique link to track your referrals automatically.</p>
            </div>
            <div className="flex bg-white/10 hover:bg-white/20 backdrop-blur-md rounded-xl p-3 border border-white/20 transition-all items-center gap-4 w-full md:w-auto overflow-hidden">
              <code className="text-xs font-mono truncate select-all">{referralUrl}</code>
              <button
                onClick={() => {
                  navigator.clipboard.writeText(referralUrl);
                  alert("Copied to clipboard!");
                }}
                className="p-2 bg-white text-[#004f6b] rounded-lg hover:bg-blue-50 transition-colors shadow-lg shadow-black/20"
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" /></svg>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Main Form Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-start">

        {/* Left Sidebar: Search Referrer */}
        <div className="lg:col-span-2 space-y-6">
          <div className="bg-white rounded-xl border border-gray-200 overflow-hidden sticky top-44">
            <div className="flex items-start flex-col p-6 border-b border-gray-100 bg-gray-50/50">
              <h3 className="font-bold text-gray-800 flex items-center gap-2">
                <svg className="w-5 h-5 text-[#004f6b]" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                Find Referrer
              </h3>
              <p className="text-xs text-gray-400 mt-1">Search the person who is recommending.</p>
            </div>

            <form onSubmit={checkforEmail} className="p-6 space-y-6">
              <div className="space-y-2">
                <label className="text-xs font-medium text-gray-500 pl-1">Identifier (Email)</label>
                <div className="relative group">
                  <input
                    type="text"
                    required
                    placeholder="Email"
                    className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#004f6b]/20 focus:border-[#004f6b] outline-none transition-all"
                    value={search}
                    onChange={(e) => setSearch(e.target.value.toLowerCase())}
                  />
                  <svg className="w-4 h-4 absolute left-3.5 top-3.5 text-gray-400 group-focus-within:text-[#004f6b] transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.206" /></svg>
                </div>
                {/* <p className="text-xs text-gray-400 pl-1">Supports Email.</p> */}
              </div>

              {error && (
                <div className="bg-red-50 text-red-600 px-4 py-2 rounded-lg text-xs font-medium border border-red-100 flex items-center gap-2 animate-pulse">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" /></svg>
                  {error}
                </div>
              )}

              <button
                type="submit"
                className="w-full py-3 bg-[#004f6b] hover:bg-[#003e54] text-white rounded-xl font-semibold text-sm transition-all 0 active:scale-95 flex items-center justify-center gap-2"
              >
                Link Referrer
              </button>
            </form>

            {/* Selection Result Block */}
            <div className="p-6 border-t border-gray-100">
              <label className="text-xs font-medium text-gray-400 pl-1">Active Referrer</label>
              <div className={`mt-3 rounded-xl p-4 transition-all border-2 ${Object.keys(userinfo).length > 0 ? 'bg-blue-50 border-[#004f6b] shadow-md' : 'bg-gray-50 border-gray-100 opacity-60'}`}>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className={`h-10 w-10 rounded-full flex items-center justify-center text-white ${Object.keys(userinfo).length > 0 ? 'bg-[#004f6b]' : 'bg-gray-300'}`}>
                      {Object.keys(userinfo).length > 0 ? userinfo.email?.charAt(0).toUpperCase() : '?'}
                    </div>
                    <div className="flex flex-col">
                      <span className={`text-sm font-semibold truncate max-w-[150px] ${Object.keys(userinfo).length > 0 ? 'text-gray-900' : 'text-gray-400'}`}>
                        {Object.keys(userinfo).length > 0 ? userinfo.email : "No Selection"}
                      </span>
                      <span className="text-xs text-start text-gray-400 font-normal">
                        {Object.keys(userinfo).length > 0 ? 'Verified Account' : 'Pending Search'}
                      </span>
                    </div>
                  </div>
                  {Object.keys(userinfo).length > 0 && (
                    <button onClick={emptySearch} className="p-1 px-2.5 rounded hover:bg-red-100 text-red-500 hover:text-red-600 transition-colors text-lg font-bold leading-none bg-white shadow-sm border border-red-50 cursor-pointer">×</button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Content: Add Referee Form */}
        <div className="lg:col-span-3">
          <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
            <div className="p-6 border-b border-gray-100 bg-gray-50/50 flex flex-col md:flex-row justify-between items-center gap-4">
              <div className="space-y-1 flex  flex-col items-start">
                <h2 className="text-xl font-bold text-gray-900">Add Referee Details</h2>
                <p className="text-sm text-gray-500 font-medium">Capture information for the person being referred.</p>
              </div>
              {/* <div className="px-3 py-1 bg-amber-50 rounded-full border border-amber-100 flex items-center gap-2">
                <div className="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse"></div>
                <span className="text-xs font-medium text-amber-700">Manual Entry</span>
              </div> */}
            </div>

            <form onSubmit={saveProxyDetail} className="p-8 space-y-8">
              {/* Names Group */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="text-xs font-medium text-gray-500 pl-1">First Name</label>
                  <input
                    type="text"
                    required
                    placeholder="Enter first name"
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#004f6b]/20 focus:border-[#004f6b] outline-none transition-all"
                    value={proxyfirstname}
                    onChange={(e) => setProxyfirstname(e.target.value)}
                  />
                </div>
                <div className="space-y-2">
                  <label className="text-xs font-medium text-gray-500 pl-1">Last Name</label>
                  <input
                    type="text"
                    required
                    placeholder="Enter last name"
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#004f6b]/20 focus:border-[#004f6b] outline-none transition-all"
                    value={proxylastname}
                    onChange={(e) => setProxylastname(e.target.value)}
                  />
                </div>
              </div>

              {/* Contact Information */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="text-xs font-medium text-gray-500 pl-1">Email Address</label>
                  <input
                    type="email"
                    required
                    placeholder="Email Address"
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#004f6b]/20 focus:border-[#004f6b] outline-none transition-all"
                    value={proxyemail}
                    onChange={(e) => setProxyemail(e.target.value.toLowerCase())}
                  />
                </div>
                <div className="space-y-2">
                  <label className="text-xs font-medium text-gray-500 pl-1">Phone Number</label>
                  <input
                    type="text"
                    required
                    placeholder="10-digit mobile"
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#004f6b]/20 focus:border-[#004f6b] outline-none transition-all"
                    value={proxyphonenumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,10}$/.test(value)) {
                        setProxyphonenumber(value);
                      }
                    }}
                  />
                </div>
              </div>

              {/* Preferences Group */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-4 border-t border-gray-100">
                <div className="space-y-2">
                  <label className="text-xs font-medium text-gray-500 pl-1">Residency</label>
                  <select
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:border-[#004f6b] outline-none transition-all text-sm font-medium"
                    value={proxycountry}
                    onChange={(e) => setProxycountry(e.target.value)}
                    required
                  >
                    <option value="" disabled>Select country</option>
                    {countries.map((country) => (
                      <option key={country} value={country}>{country}</option>
                    ))}
                  </select>
                </div>
                <div className="space-y-2">
                  <label className="text-xs font-medium text-gray-500 pl-1">Interested Program</label>
                  <select
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:border-[#004f6b] outline-none transition-all text-sm font-medium"
                    value={proxyprogram}
                    onChange={(e) => setProxyprogram(e.target.value)}
                    required
                  >
                    <option value="MBA">MBA</option>
                    <option value="MCA">MCA</option>
                    <option value="M.Com">M.Com</option>
                    <option value="MA">MA</option>
                    <option value="BBA">BBA</option>
                    <option value="BCA">BCA</option>
                    <option value="B.Com">B.Com</option>
                  </select>
                </div>
              </div>

              {/* Status Output */}
              <div className="space-y-2">
                {referralerror && <p className="text-red-600 text-xs font-medium">Email Error: {referralerror}</p>}
                {errorPhone && <p className="text-red-600 text-xs font-medium">Phone Error: {errorPhone}</p>}
                {errormessage && <p className="text-red-700 text-sm font-medium bg-red-50 p-3 rounded-lg border border-red-100">{errormessage}</p>}
                {referrermessage && <p className="text-red-700 text-xs font-medium bg-red-50 p-2 rounded border border-red-100">Selection Required: {referrermessage}</p>}
              </div>

              <div className="pt-4 flex flex-col md:flex-row gap-4">
                <button
                  type="button"
                  onClick={resetForm}
                  className="px-8 py-3.5 border border-gray-200 text-gray-500 rounded-xl font-semibold text-sm hover:bg-gray-50 transition-all"
                >
                  Clear Fields
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`flex-grow px-8 py-3.5 bg-[#004f6b] hover:bg-[#003e54] text-white rounded-xl font-semibold text-sm transition-all hover:shadow-lg hover:shadow-[#004f6b]/20 flex items-center justify-center gap-3 ${isSubmitting ? 'opacity-70 cursor-not-allowed translate-y-0.5' : 'active:translate-y-0.5 hover:-translate-y-0.5'}`}
                >
                  {isSubmitting ? 'Registering...' : 'Complete Registration'}
                  {!isSubmitting && (
                    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>

      </div>

      {/* Success Popup */}
      {successmessage && createPortal(
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
          <div
            className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm animate-fadeIn"
            onClick={() => setSuccessmessage("")}
          ></div>
          <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md p-8 animate-zoomIn border border-gray-100">
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-4">
                <svg className="w-9 h-9 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Success</h3>
              <p className="text-sm text-gray-600 mb-6">{successmessage}</p>
              <button
                type="button"
                onClick={() => setSuccessmessage("")}
                className="px-8 py-2.5 bg-[#004f6b] hover:bg-[#003e54] text-white rounded-xl font-semibold text-sm transition-all active:scale-95"
              >
                Done
              </button>
            </div>
          </div>
          <style jsx>{`
            @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
            @keyframes zoomIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
            .animate-fadeIn { animation: fadeIn 0.2s ease-out forwards; }
            .animate-zoomIn { animation: zoomIn 0.25s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
          `}</style>
        </div>,
        document.body
      )}
    </div>
  );
};

export default Add;
